(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .controller('MassEmailController', MassEmailController);

  /* ngInject */
  function MassEmailController($state, $log, Flash, formErrorsService, massEmailService, sessionService) {

    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.email = {};
    vm.emailForm = {};
    vm.createEmail = createEmail;

    function createEmail(email) {
      vm.clearFormErrors(vm.emailForm);
      massEmailService(sessionService.getAuthToken()).save(email, _createEmailSuccess, _createEmailFailure);
      //enhancementService(sessionService.getAuthToken()).save(enhancement, createEnhancementSuccess, createEnhancementFailure);
    }

    function _createEmailSuccess(_response) {
      Flash.create('success', 'The email request was successfully sent.');
      $state.go('application.compliance_services.dashboard');
    }

    function _createEmailFailure(error) {
      Flash.create('danger', 'An error occurred creating the email request. Please correct the errors on the form and resubmit.');
      vm.setFormErrors(vm.emailForm, error);
    }

  }
})();
